import { LegalPage, LegalSection } from "./Legal";

const Security = () => (
  <LegalPage
    eyebrow="Trust"
    title={<>Security at <span className="text-gradient">Cloudease</span></>}
    description="How we operate our own infrastructure — and how we help customers operate theirs — with security built in from day one."
    seoTitle="Security — Cloudease"
    seoDescription="How Cloudease protects customer data, operates infrastructure securely, and supports responsible vulnerability disclosure."
    path="/security"
    updated="April 2026"
  >
    <p className="text-sm text-muted-foreground">
      This page is maintained by Cloudease to answer common security and privacy questions about how we operate our own systems and support customer engagements. It is not an independent certification.
    </p>

    <LegalSection title="Shared responsibility">
      <p>Customer production workloads run inside the customer's own cloud accounts (AWS, Azure, GCP). Cloudease designs, deploys, and operates those environments under least-privilege access — customers retain ownership and the ultimate control plane. This page covers our own website and internal tooling.</p>
    </LegalSection>
    <LegalSection title="Access and authentication">
      <p>Access to Cloudease-managed systems is restricted to authorized team members. Administrative interfaces — including our internal admin dashboard — require multi-factor authentication (TOTP) in addition to a password, with short session lifetimes and automatic re-authentication.</p>
    </LegalSection>
    <LegalSection title="Platform and hosting">
      <p>The Cloudease website is hosted on AWS Amplify. Application data is stored on managed Postgres with row-level security enforced at the database layer. Traffic is served exclusively over TLS.</p>
    </LegalSection>
    <LegalSection title="Data we collect">
      <p>We collect only what we need to respond to inquiries and improve the site: contact-form fields, page visits with approximate geolocation, and IP addresses. See our <a className="text-primary hover:underline" href="/privacy">Privacy Policy</a> for the full picture.</p>
    </LegalSection>
    <LegalSection title="Encryption">
      <p>Data is encrypted in transit using TLS 1.2+ and at rest using the encryption defaults provided by our managed database and storage providers.</p>
    </LegalSection>
    <LegalSection title="Subprocessors">
      <p>We rely on a small set of vetted subprocessors to operate the site — including our hosting, database, email delivery, and analytics providers. Each is bound by contract to appropriate security and confidentiality obligations.</p>
    </LegalSection>
    <LegalSection title="Incident response">
      <p>If we detect a security incident affecting personal data, we investigate immediately, contain the issue, notify affected parties as required by law, and share a post-incident summary.</p>
    </LegalSection>
    <LegalSection title="Responsible disclosure">
      <p>Found a vulnerability? Please email <a className="text-primary hover:underline" href="mailto:hello@cloudease.in">hello@cloudease.in</a> with details and reproduction steps. We commit to acknowledging your report within two business days and to not pursuing action against good-faith researchers who follow responsible disclosure.</p>
    </LegalSection>
    <LegalSection title="Compliance">
      <p>We align our internal practices with widely-accepted frameworks (NIST CSF, CIS Benchmarks) and help customers achieve their own SOC 2, ISO 27001, HIPAA, and PCI objectives through the environments we design for them. Cloudease is not itself audited under those frameworks today.</p>
    </LegalSection>
    <LegalSection title="Contact">
      <p>Security questions: <a className="text-primary hover:underline" href="mailto:hello@cloudease.in">hello@cloudease.in</a></p>
    </LegalSection>
  </LegalPage>
);

export default Security;
